<template>
  <div class="modal fade" tabindex="-1" role="dialog" id="celebrate-subscription-modal">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <form @submit.prevent="submit">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">
                &times;
              </span>
            </button>

            <h4 class="modal-title">
              Celebrate Subscription
            </h4>
          </div>

          <div class="modal-body">
            <text-form-group
                v-model="data.text"
                name="text"
                label="Text"
                :error="getError('text')"
            ></text-form-group>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">
              Close
            </button>

            <button type="submit" class="btn btn-black">
              <i class="fa fa-glass-cheers"></i> Celebrate
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import notify from '@/notify'
import Errors from '@/mixins/Errors'
import TextFormGroup from '@/vendor/forms/FormGroups/Block/Text'

export default {
  components: {TextFormGroup},

  mixins: [Errors],

  props: ['subscription'],

  data() {
    return {
      data: {}
    }
  },

  mounted() {
    this.listenForClose()
  },

  methods: {
    listenForClose() {
      $(this.$el).on('hidden.bs.modal', this.reset)
    },

    submit() {
      http.post('/api/v2/subscriptions/'+this.subscription.data.id+'/celebrate', this.data)
          .then(() => {
            this.$emit('celebrated')

            $(this.$el).modal('hide')
          })
          .catch(error => {
            if (error.response.status === 400) {
              return notify.error(error.response.data.message)
            }

            throw error
          })
          .catch(this.catchValidationErrors)
    },

    reset() {
      this.errors = {}

      this.text = null
    }
  }
}
</script>
